module.exports = __webpack_public_path__ + "img/brushes-2_en.1304730.jpg";